export function findParentElement(dom: HTMLElement, className: string) {
  let target = dom;

  while (target !== null) {
    if (target.classList && target.classList.contains(className)) {
      return target;
    }
    target = target.parentElement as HTMLElement;
  }

  return null;
}

export function findElementWithClass(event: MouseEvent, className: string) {
  let target = event.target as HTMLElement;

  return findParentElement(target, className);
}

// 寻找某个dom或他最近一级的祖先元素里满足某个属性的元素
export const findClosesElement = (
  element: HTMLElement | null,
  expression: (element: HTMLElement) => boolean,
): HTMLElement | null => {
  let currentElement: HTMLElement | null = element;
  while (currentElement) {
    if (expression(currentElement)) {
      return currentElement;
    }
    currentElement = currentElement.parentElement;
  }
  return null;
};
